import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

export interface CompareModeState {
  firstCompareModel?: string;
  secondCompareModel?: string;
}

const initialState = {
  firstCompareModel: undefined,
  secondCompareModel: undefined,
} as CompareModeState;

export const compareModeSlice = createSlice({
  name: 'compareModePersist',
  initialState,
  reducers: {
    setFirstCompareModel: (
      state,
      { payload }: PayloadAction<string | undefined>,
    ) => {
      state.firstCompareModel = payload;
    },
    setSecondCompareModel: (
      state,
      { payload }: PayloadAction<string | undefined>,
    ) => {
      state.secondCompareModel = payload;
    },
  },
});

export const compareModeState = (state: RootState) =>
  state.compareModePersist as CompareModeState;

export const { setFirstCompareModel, setSecondCompareModel } =
  compareModeSlice.actions;

export default compareModeSlice.reducer;
